const AssetType = {
	IMAGE: 'image',
	VIDEO: 'video',
} as const;

export default AssetType;
